<template>
  <div class="lang-select">
    <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
      <div>
        <svg-icon class-name="country-icon" icon-class="attach-country" />
        <span class="lang-text">{{ comCountryName($store.getters.curCountry.country_code) }} <span v-if="$store.getters.curCountry.country_code !== 'HK-USD'">({{ comCountryCurrency($store.getters.curCountry.country_code) }})</span> </span>
        <i class="el-icon-caret-bottom icon-arrow-down" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="country in onlineCountryList" :key="country.code" :disabled="$store.getters.curCountry.country_code === country.code" :command="country.code">
          <div class="country-text"> {{ language === 'zh' ? country.cn_name : country.en_name }}  <span v-if="country.code !== 'HK-USD'"> ({{ country.currency }}) </span></div>

        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>

</template>

<script>
import { fetchOnlineCountryList, changeCountry } from '@/api/components/components.js'

export default {
  data() {
    return {
      onlineCountryList: []
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    comCountryName() {
      return function(code) {
        const i = this.onlineCountryList.find(item => item.code === code)
        if (!i) {
          return ''
        }
        return this.language === 'zh' ? i.cn_name : i.en_name
      }
    },
    comCountryCurrency() {
      return function(code) {
        const i = this.onlineCountryList.find(item => item.code === code)
        if (!i) {
          return ''
        }
        return i.currency
      }
    }
  },
  created() {
    this.getOnlineCountry()
  },
  methods: {
    handleSetLanguage(country_code) {
      changeCountry({ country_code }).then(res => {
        const { name } = this.$route
        // 兼容再sendPayment页面切换国家没权限显示404，解决先跳到首页
        const pageName = ['Online_Large_Value_Payment', 'Online_Large_Payout_Approval']
        if (pageName.includes(name) && country_code !== 'PH') {
          this.$router.push('/')
        }
        location.reload()
      })
    },
    getOnlineCountry() {
      fetchOnlineCountryList().then(res => {
        const list = res.data || []
        this.$store.commit('page/UPDATE_COUNTRY_ARR', list)
        this.onlineCountryList = list.filter(item => !['CN'].includes(item.code))
      })
    }
  }
}
</script>
<style scoped>
  /* ::v-deep .el-dropdown-menu__item.is-disabled .country-text{
    color: #488CE8;
  } */
  .country-text{
    /* color: rgba(54, 66, 80, 0.50); */
    font-size: 12px;
    margin-right: 50px;
    font-weight: 400;
  }
.lang-select{
  position: relative;
  top: -4px;
}
.lang-text{
  margin-right: 8px;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 12px;
  color: #364250;
}

.icon-arrow-down{
  margin-left: 12px;;
  font-size: 12px;
  font-weight: bold;
}
.country-icon{
  font-size: 18px;
}
@media screen and (max-width: 761px) {
 .lang-text{
  display: none;
 }
}
</style>
